import ContentStorage, { ComponentKeys } from '../tnew/content/ContentStorage';


function getProperty(name) {
  return ContentStorage.get(ComponentKeys.SYOS, name);
}


class SyosPageComponent {
  static get selectedSeatsHeader() {
    return getProperty('SelectedSeatsHeader');
  }

  static get addToCartButton() {
    return getProperty('AddToCartButton');
  }

  static get subtotalLabel() {
    return getProperty('SubtotalLabel');
  }

  static get viewFullMapLink() {
    return getProperty('ViewFullMapLink');
  }

  static get viewEventDetailsButtonLabel() {
    return getProperty('ViewEventDetailsButtonLabel');
  }

  static get backToSeatMapButtonLabel() {
    return getProperty('BackToSeatMapButtonLabel');
  }

  static get cancelButton() {
    return getProperty('CancelButton');
  }

  static get removeButton() {
    return getProperty('RemoveButton');
  }

  static get removeSeatConfirmationMessage() {
    return getProperty('RemoveSeatConfirmationMessage');
  }

  static get labelSeatStatusSelected() {
    return getProperty('LabelSeatStatusSelected');
  }

  static get labelSeatStatusUnavailable() {
    return getProperty('LabelSeatStatusUnavailable');
  }

  static get labelSeatTypeSpecial() {
    return getProperty('LabelSeatTypeSpecial');
  }

  static get labelSeatTypeWheelchair() {
    return getProperty('LabelSeatTypeWheelchair');
  }

  static get labelSeatTypeNotForSale() {
    return getProperty('LabelSeatTypeNotForSale');
  }

  static get legendLabel() {
    return getProperty('LegendLabel');
  }

  static busyIndicatorReservingSeats = 'Reserving seats';

  static busyIndicatorReservationSuccessful = 'Reservation successful';

  static busyIndicatorLoading = 'Loading';

  static busyIndicatorAjaxError = 'An error has occurred';

  static removeSeatConfirmationTitle = 'Remove Seat';

  static maximumSeatsReachedModalTitle = 'Seat Limit Reached';

  static reservationFailureModalTitle = 'Unable to Reserve Seats';

  static ajaxErrorModalTitle = 'An Error Has Occurred';

  static ajaxErrorModalMessage = '<p>Please refresh the page to try selecting seats again.</p><p>You may also click the “Let us choose the best seats for you” link on this page to have the best seats selected for you, or please contact us directly for assistance.</p>';
}


export default SyosPageComponent;



// WEBPACK FOOTER //
// ./src/syos/SyosPageComponent.js